import React from 'react'

const StoryStep = ({ data, onChange, onBack, onSubmit, isSubmitting, submitError, submitSuccess }) => {
  // Add CSS for spinner animation
  React.useEffect(() => {
    const style = document.createElement('style')
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `
    document.head.appendChild(style)
    return () => {
      document.head.removeChild(style)
    }
  }, [])
  const handleSubmit = async (e) => {
    e.preventDefault()
    if (onSubmit) {
      await onSubmit()
    }
  }

  return (
    <div className="view active">
      <div className="panel">
        <div className="panel-head" style={{
          background: 'linear-gradient(135deg,var(--navy) 0%,var(--navy3) 100%)',
          padding: '32px 36px 28px',
          borderBottom: '3px solid var(--gold)'
        }}>
          <div className="panel-title" style={{
            fontFamily: 'var(--font-d)',
            fontSize: '26px',
            color: 'var(--white)',
            marginBottom: '6px'
          }}>
            Story Protocol IP Registration
          </div>
          <div className="panel-subtitle" style={{
            fontSize: '14px',
            color: 'rgba(255,255,255,0.55)',
            fontWeight: '300'
          }}>
            Register your NIL on the Story Protocol blockchain through IPST's custodial wallet system.
          </div>
        </div>
        
        <div className="panel-body" style={{ padding: '36px' }}>
          <form onSubmit={handleSubmit}>
            <div style={{
              background: 'var(--navy)',
              borderRadius: 'var(--r2)',
              padding: '22px 24px',
              display: 'flex',
              gap: '18px',
              alignItems: 'flex-start',
              marginBottom: '24px'
            }}>
              <div style={{ fontSize: '28px', flexShrink: 0, marginTop: '2px' }}>⛓️</div>
              <div style={{ flex: 1 }}>
                <div style={{
                  fontSize: '13px',
                  fontWeight: '700',
                  color: 'var(--gold2)',
                  marginBottom: '8px'
                }}>
                  IPST Master Wallet — All NIL Token Activity
                </div>
                <div style={{
                  fontSize: '13px',
                  color: 'rgba(255,255,255,0.65)',
                  lineHeight: '1.7',
                  marginBottom: '14px'
                }}>
                  All Story Protocol IP Account (IPA) registrations, PIL sub-license minting, and oracle royalty vault operations are executed through the 
                  <strong style={{ color: 'var(--white)' }}> IPST Master Wallet</strong> — a multi-signature institutional wallet managed by IP Strategy Holdings, Inc. (Nasdaq: IPST). 
                  You do not need a personal blockchain wallet. IPST handles all on-chain transactions on your behalf as your registered IP agent.
                </div>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr',
                  gap: '10px'
                }}>
                  <div style={{
                    background: 'rgba(255,255,255,0.05)',
                    borderRadius: 'var(--r)',
                    padding: '12px'
                  }}>
                    <div style={{
                      fontSize: '10px',
                      color: 'rgba(255,255,255,0.4)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.09em',
                      marginBottom: '5px'
                    }}>
                      Wallet type
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: 'var(--white)',
                      fontWeight: '600'
                    }}>
                      Multi-sig institutional
                    </div>
                  </div>
                  <div style={{
                    background: 'rgba(255,255,255,0.05)',
                    borderRadius: 'var(--r)',
                    padding: '12px'
                  }}>
                    <div style={{
                      fontSize: '10px',
                      color: 'rgba(255,255,255,0.4)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.09em',
                      marginBottom: '5px'
                    }}>
                      Key custody
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: 'var(--white)',
                      fontWeight: '600'
                    }}>
                      IPST HSM · BitGo
                    </div>
                  </div>
                  <div style={{
                    background: 'rgba(255,255,255,0.05)',
                    borderRadius: 'var(--r)',
                    padding: '12px'
                  }}>
                    <div style={{
                      fontSize: '10px',
                      color: 'rgba(255,255,255,0.4)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.09em',
                      marginBottom: '5px'
                    }}>
                      Network
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: '#4ade80',
                      fontWeight: '600'
                    }}>
                      Story Protocol · Chain 1514
                    </div>
                  </div>
                </div>
                <div style={{
                  marginTop: '12px',
                  padding: '10px 14px',
                  background: 'rgba(13,158,124,0.12)',
                  border: '1px solid rgba(13,158,124,0.25)',
                  borderRadius: 'var(--r)'
                }}>
                  <div style={{
                    fontSize: '11px',
                    color: 'rgba(255,255,255,0.5)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.08em',
                    marginBottom: '4px'
                  }}>
                    IPST Master Wallet Address
                  </div>
                  <div style={{
                    fontFamily: 'var(--font-m)',
                    fontSize: '12px',
                    color: '#4ade80'
                  }}>
                    0x4953545f4d41535445525f57414c4c45545f494e43
                  </div>
                </div>
              </div>
            </div>

            {/* Success Message */}
            {submitSuccess && (
              <div style={{
                textAlign: 'center',
                padding: '40px',
                background: 'rgba(13,158,124,0.1)',
                borderRadius: 'var(--r2)',
                border: '2px solid rgba(13,158,124,0.3)',
                marginBottom: '24px'
              }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎉</div>
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#10b981',
                  marginBottom: '8px'
                }}>
                  Registration Completed Successfully!
                </h3>
                <p style={{
                  fontSize: '14px',
                  color: 'var(--text3)',
                  lineHeight: '1.6'
                }}>
                  Your athlete profile has been created and all data has been saved to the database.
                </p>
              </div>
            )}

            {/* Error Message */}
            {submitError && (
              <div style={{
                padding: '16px',
                background: 'rgba(239,68,68,0.1)',
                border: '1px solid rgba(239,68,68,0.3)',
                borderRadius: 'var(--r)',
                marginBottom: '24px'
              }}>
                <div style={{
                  fontSize: '14px',
                  color: '#ef4444',
                  fontWeight: '600',
                  marginBottom: '4px'
                }}>
                  Registration Failed
                </div>
                <div style={{
                  fontSize: '13px',
                  color: 'var(--text3)',
                  lineHeight: '1.5'
                }}>
                  {submitError}
                </div>
              </div>
            )}

            <div style={{
              textAlign: 'center',
              padding: '40px',
              background: 'var(--off)',
              borderRadius: 'var(--r2)',
              border: '2px dashed var(--border)'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎯</div>
              <h3 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: 'var(--text)',
                marginBottom: '8px'
              }}>
                Story Protocol Integration Coming Soon
              </h3>
              <p style={{
                fontSize: '14px',
                color: 'var(--text3)',
                lineHeight: '1.6'
              }}>
                This step will handle blockchain registration, IP asset creation, and smart contract interactions.
              </p>
            </div>

            <div className="btn-actions" style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'flex-end',
              marginTop: '28px',
              paddingTop: '24px',
              borderTop: '1px solid var(--border)'
            }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onBack}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  padding: '13px 28px',
                  borderRadius: 'var(--r)',
                  fontFamily: 'var(--font-b)',
                  fontSize: '14px',
                  fontWeight: '600',
                  letterSpacing: '0.02em',
                  cursor: 'pointer',
                  border: '1.5px solid var(--border)',
                  background: 'transparent',
                  color: 'var(--text2)',
                  transition: 'all 0.2s'
                }}
              >
                ← Back
              </button>
              <button
                type="submit"
                className="btn btn-teal"
                disabled={isSubmitting || submitSuccess}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  padding: '13px 28px',
                  borderRadius: 'var(--r)',
                  fontFamily: 'var(--font-b)',
                  fontSize: '14px',
                  fontWeight: '600',
                  letterSpacing: '0.02em',
                  cursor: isSubmitting || submitSuccess ? 'not-allowed' : 'pointer',
                  border: 'none',
                  transition: 'all 0.2s',
                  background: isSubmitting || submitSuccess ? 'var(--text3)' : 'var(--teal)',
                  color: 'var(--white)',
                  opacity: isSubmitting || submitSuccess ? 0.7 : 1
                }}
              >
                {isSubmitting ? (
                  <>
                    <div style={{
                      width: '14px',
                      height: '14px',
                      border: '2px solid rgba(255,255,255,0.3)',
                      borderTop: '2px solid white',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    Processing...
                  </>
                ) : submitSuccess ? (
                  <>
                    ✓ Registration Complete
                  </>
                ) : (
                  <>
                    Complete Registration ✓
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default StoryStep
